import Button from 'components/Button'
import NotificationButton from 'components/NotificationButton'
import { View } from 'components/View'
import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'
import { NOTIFICATIONS_DOMAIN } from 'modules/notifications/constants'
import { getUnreadCountNotificationsUtil } from 'modules/notifications/utils'
import { getInstancesDomainSelector } from 'modules/redux/selectors/domain'
import React from 'react'
import { createSelector } from 'reselect'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'

const getUnreadCountNotificationsSelect = createSelector(
  getInstancesDomainSelector(NOTIFICATIONS_DOMAIN),
  instances => getUnreadCountNotificationsUtil(instances)
)

export default function HeaderNotifications ({ size = NotificationButton.SIZE.SMALLER }) {
  const unreadCount = useSelector(getUnreadCountNotificationsSelect)

  const dispatch = useDispatch()
  const handleClick = () => {
    dispatch(
      openModalAction(MODAL_ID.NOTIFICATIONS_MENU)
    )
  }

  return (
    <Button
      onClick={handleClick}
      name='notifications'
      style={{
        width: '3em'
      }}
    >
      <View
        style={{
          justifyContent: View.JUSTIFY.CENTER,
          alignItems: View.ALIGN.CENTER,
          width: '2.22em',
          height: '2.22em',
          color: '#666666',
          transition: 'color 0.125s ease-out'
        }}
      >
        <NotificationButton
          value={unreadCount}
          size={size}
        />
      </View>
    </Button>
  )
}
